
import React, { useState } from 'react';
import { Button, Nav } from 'react-bootstrap';
import { FaCheck, FaFilePdf, FaClipboardList, FaFileSignature } from 'react-icons/fa';
import { MdDownload, MdDescription } from 'react-icons/md';
import { LuFiles, LuClipboardList } from "react-icons/lu";
import { connect } from 'react-redux';
import { aceptar_oferta } from "../../services/ofertas";
import { print_contrato_pdf } from "../../services/auxiliares";
import { send_document_signaturit } from "../../services/signaturit";
import GestionArchivosOferta from '../modals/GestionArchivosOferta';
import NotasOferta from '../modals/NotasOferta';
import SendSignaturitModal from '../modals/SendSignaturitModal';
import { getOfferSignaturitEmail } from '../../utils/signaturit';


// Helper function to detect MIME type and extension from Base64
const determineContentTypeAndExtension = (base64Data) => {
    // Common mappings
    const signatures = {
        JVBERi0: { contentType: "application/pdf", extension: "pdf" },
        R0lGODdh: { contentType: "image/gif", extension: "gif" },
        R0lGODlh: { contentType: "image/gif", extension: "gif" },
        iVBORw0KGgo: { contentType: "image/png", extension: "png" },
        "/9j/": { contentType: "image/jpg", extension: "jpg" },
    };

    for (const signature in signatures) {
        if (base64Data.startsWith(signature)) {
            return signatures[signature];
        }
    }

    // Default to plain text or binary if unknown
    return { contentType: "application/octet-stream", extension: "bin" };
};

const SidebarOfferActions = ({ oferta, user, onRefresh }) => {
    // Modal states (internal to this component)
    const [showGestionArchivos, setShowGestionArchivos] = useState(false);
    const [showNotas, setShowNotas] = useState(false);
    const [showSignaturit, setShowSignaturit] = useState(false);

    if (!oferta) return null;

    const canAct = oferta.state === "Solicitud oferta" || oferta.state === "Contrato enviado";

    // --- Action Handlers ---
    const handleAceptar = async () => {
        if (!oferta.id || !oferta.sector_type) return;
        await aceptar_oferta(oferta.id, user.id, oferta.sector_type);
        if (onRefresh) onRefresh();
    };

    const handleImprimirContrato = async () => {
        try {
            const polissaId = oferta.polissa_id?.[0]; // Assuming array or single value
            const archivo = await print_contrato_pdf(user.id, oferta.id, polissaId);
            if (!archivo || typeof archivo !== 'object') return;

            Object.keys(archivo).forEach((arch) => {
                const { datas: base64Data, name: originalName } = archivo[arch];
                const { contentType, extension } = determineContentTypeAndExtension(base64Data);

                const byteCharacters = atob(base64Data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                const blob = new Blob([byteArray], { type: contentType });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);

                link.download = originalName || `archivo.${extension}`;
                link.click();
                URL.revokeObjectURL(link.href);
            });
        } catch (error) {
            console.error("Error al descargar el archivo:", error);
        }
    };

    const handleConfirmSignaturit = async (email, signatureType) => {
        try {
            await send_document_signaturit(oferta.id, signatureType, email);
        } catch (err) {
            console.error("Error al enviar a Signaturit:", err);
        } finally {
            if (onRefresh) onRefresh();
        }
    };

    const ActionItem = ({ icon: Icon, label, onClick, variant = "outline-secondary" }) => (
        <Nav.Item className="mb-2">
            <Button
                variant={variant}
                className="w-100 text-start d-flex align-items-center gap-2 border-0 bg-transparent ps-0"
                onClick={onClick}
                style={{ color: 'inherit' }}
            >
                <div className="d-flex align-items-center justify-content-center bg-light rounded-circle" style={{ width: '32px', height: '32px' }}>
                    <Icon size={14} />
                </div>
                <span style={{ fontSize: '0.9rem' }}>{label}</span>
            </Button>
        </Nav.Item>
    );

    return (
        <div className="sidebar-actions-container mt-4 animate-fade-in">
            <h6 className="sidebar-section-title">
                Acciones
            </h6>
            <Nav className="flex-column">
                {canAct && (
                    <>
                        <ActionItem
                            icon={FaCheck}
                            label="Aceptar Oferta"
                            onClick={handleAceptar}
                            variant="success"
                        />
                        <ActionItem
                            icon={MdDownload}
                            label="Descargar Contrato"
                            onClick={handleImprimirContrato}
                        />
                        <ActionItem
                            icon={FaFileSignature}
                            label="Enviar a Firmar"
                            onClick={() => setShowSignaturit(true)}
                        />
                    </>
                )}

                <ActionItem
                    icon={LuFiles}
                    label="Gestionar Archivos"
                    onClick={() => setShowGestionArchivos(true)}
                />

                <ActionItem
                    icon={LuClipboardList}
                    label="Ver Notas"
                    onClick={() => setShowNotas(true)}
                />
            </Nav>

            {/* Modals */}
            <GestionArchivosOferta
                show={showGestionArchivos}
                close={setShowGestionArchivos}
                oferta={{ id: oferta.id, name: oferta.name }}
            />
            <NotasOferta
                show={showNotas}
                close={setShowNotas}
                oferta={{ id: oferta.id, name: oferta.name }}
                user={user}
            />
            <SendSignaturitModal
                show={showSignaturit}
                onHide={() => setShowSignaturit(false)}
                onClose={() => setShowSignaturit(false)}
                onConfirm={handleConfirmSignaturit}
                defaultEmail={getOfferSignaturitEmail(oferta)}
                signatureType="email"
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    user: state.Auth.user
});

export default connect(mapStateToProps)(SidebarOfferActions);
